export default __webpack_public_path__ + "static/media/Vendomatica.7e55ddf1.svg";